import { useDelegateSurveyWorkgroupMutation, useUpdateSurveyWorkgroupMutation } from '@api/workgroups';
import { SURVEY } from '@constants/terminology';
import { DelegateWorkgroupModalBase } from '@features/delegation';
import { SurveyWorkgroup } from '@g17eco/types/workgroup';
import { SurveyDelegationProps } from '../types';

interface Props extends Pick<SurveyDelegationProps, 'survey' | 'metricGroups'> {
  isOpen: boolean;
  toggle: () => void;
  delegatedWorkgroups: SurveyWorkgroup[];
  editingWorkgroup?: SurveyWorkgroup;
}

export const DelegateWorkgroupModal = ({
  isOpen,
  toggle,
  survey,
  metricGroups,
  delegatedWorkgroups,
  editingWorkgroup,
}: Props) => {
  const [delegateWorkgroup, { isLoading: isDelegating }] = useDelegateSurveyWorkgroupMutation();
  const [updateSurveyWorkgroup, { isLoading: isUpdating }] = useUpdateSurveyWorkgroupMutation();

  return (
    <DelegateWorkgroupModalBase
      isOpen={isOpen}
      toggle={toggle}
      entity={survey}
      metricGroups={metricGroups}
      delegatedWorkgroups={delegatedWorkgroups}
      editingWorkgroup={editingWorkgroup}
      isLoading={isDelegating || isUpdating}
      entityLabel={SURVEY.SINGULAR}
      handlers={{
        onDelegate: async ({ workgroupIds, permission }) => {
          await delegateWorkgroup({
            surveyId: survey._id,
            workgroupIds,
            permission,
          }).unwrap();
        },
        onUpdate: async ({ workgroupId, permission }) => {
          await updateSurveyWorkgroup({
            surveyId: survey._id,
            workgroupId,
            permission,
          }).unwrap();
        },
      }}
    />
  );
};
